/* tslint:disable */

/**
 */
export class Coord {
    x?: void[];
    y?: void[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/coord.ts